import { axiosInstanceV2 } from "./AxiosInstance";
import { cachedRequest, clearCache } from "./requestCache";

// import { axiosInstanceV2 } from './AxiosInstance';
const API_URL = '/users';
const USERS_PAGE_CAP = 100;
const USERS_DEFAULT_LIMIT = 10;

export const getUsers = async (limit = 10, page = 1, search = "", searchField = "") => {
  try {
    let queryParams = `?limit=${limit}&page=${page}`
    if (search) {
      queryParams += `&search=${encodeURIComponent(search)}`
    }
    if (searchField) {
      queryParams += `&searchField=${searchField}`
    }
    const response = await axiosInstanceV2.get(`${API_URL}${queryParams}`)
    return {
      data: response.data.data,
      pagination: response.data.pagination,
    }
  } catch (error) {
    console.error("Error fetching users", error)
    throw error
  }
}

export const listUsersByIds = async (userIds = [], emails = []) => {
  return cachedRequest(`users:listByIds:${(userIds || []).join(',')}:${(emails || []).join(',')}`, 30000, async () => {
    try {
      const response = await axiosInstanceV2.post(`${API_URL}/list`, { userIds, emails });
      return response.data;
    } catch (error) {
      console.error('Error fetching users by ids', error);
      throw error;
    }
  });
};

export const getUser = async (id) => {
  return cachedRequest(`users:byId:${id}`, 30000, async () => {
    try {
      const response = await axiosInstanceV2.get(`${API_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching user', error);
      throw error;
    }
  });
};

export const addUser = async (userData) => {
  try {
    const response = await axiosInstanceV2.post(API_URL, userData);
    clearCache("users:");
    return response.data;
  } catch (error) {
    console.error('Error adding user', error);
    throw error;
  }
};

export const updateUser = async (user, userId) => {
  try {
    const response = await axiosInstanceV2.put(`${API_URL}/${userId}`, user);
    clearCache("users:");
    return response.data;
  } catch (error) {
    console.error('Error updating user', error);
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await axiosInstanceV2.delete(`${API_URL}/${userId}`);
    clearCache("users:");
    return response.data;
  } catch (error) {
    console.error('Error deleting user', error);
    throw error;
  }
};
